import React, { useContext } from 'react';
import { AppContext } from '../context';
import tw from 'twin.macro';
import { Title } from './';

export const TitleRow = ({
  Type = 'h1',
  children,
  text = children,
  LeftBlock,
  RightBlock,
  mobileRow,
  sticky,
  ...restProps
}) => {
  const { slideIn } = useContext(AppContext);
  return (
    <div
      css={[
        sticky && tw`sticky z-30 bg-primary transition-all duration-200`,
        !slideIn.active && sticky && tw`top-14`,
        slideIn.active && sticky && tw`top-0`,
      ]}
      {...restProps}
    >
      <div
        css={[
          tw`h-14 flex justify-between items-center w-full`,
          mobileRow && tw`flex-col md:flex-row`,
        ]}
      >
        {LeftBlock && <LeftBlock />}
        <Title
          Type={Type}
          tw='whitespace-nowrap mr-2 overflow-hidden text-ellipsis'
          marginBottom={false}
        >
          {text}
        </Title>
        {RightBlock && <RightBlock />}
      </div>
    </div>
  );
};
